import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';

export type SGSCurrencyFieldProps = {
    name: string;
    label?: string;
    variant?: 'standard' | 'outlined' | 'filled';
    currencySymbol?: string;
    decimalCharacter?: string;
    digitGroupSeparator?: string;
    minimumValue?: string;
    value?: number;
    helperText?: string;
    disabled?: boolean;
    allowNegative?: boolean;
};

const SGSInputCurrency: React.FC<SGSCurrencyFieldProps> = ({
    name,
    label = null,
    variant = 'outlined',
    currencySymbol = '€',
    decimalCharacter = ',',
    digitGroupSeparator = ' ',
    minimumValue = '0',
    value = 0,
    helperText,
    disabled = false,
    allowNegative = false,
    ...props
}) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    const { t } = useTranslation();

    const getErrorMessage = useCallback((errors, path) => {
        return path.split('.').reduce((obj, key) => obj && obj[key], errors)?.message || null;
    }, []);

    const errorMessage = getErrorMessage(errors, name);

    return (
        <FormControl variant={variant} error={!!errorMessage} fullWidth>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value: fieldValue, ...restField } }) => (
                    <NumericFormat
                        {...restField}
                        {...props}
                        id={name}
                        label={t(label)}
                        customInput={TextField}
                        error={!!errorMessage}
                        variant={variant}
                        value={fieldValue || value}
                        thousandSeparator={digitGroupSeparator}
                        decimalSeparator={decimalCharacter}
                        decimalScale={2}
                        fixedDecimalScale
                        disabled={disabled}
                        suffix={` ${currencySymbol}`}
                        allowNegative={allowNegative}
                        onChange={(e) => {
                            const numericValue = e.target.value.replace(currencySymbol, '').replace(digitGroupSeparator, '').replace(decimalCharacter, '.');
                            onChange(numericValue);
                        }}
                        InputProps={{
                            inputProps: { style: { textAlign: 'right' } },
                        }}
                    />
                )}
            />
            {(helperText || errorMessage) && <FormHelperText error={!!errorMessage}>{errorMessage || helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SGSInputCurrency;
